import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ConfirmDialogContainerComponent } from './containers/confirm-dialog/confirm-dialog-container.component';
import { CorePipesModule } from '@fleet-beat/libs-core/src/lib/pipes/core-pipes.module';
import { MatRippleModule } from '@angular/material/core';

@NgModule({
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, CorePipesModule, MatRippleModule],
  declarations: [ConfirmDialogContainerComponent],
  entryComponents: [ConfirmDialogContainerComponent],
})
export class ConfirmDialogModule {}
